module.exports = __webpack_public_path__ + "static/media/BiennalProject.2c980fb7.png";